import actions from './actions'

const initialState = {
  metricsDcu: [],
  metricsHau: [],
  metricsCcu: [],
  metricsMau: [],
  metricsMcu: [],
  metricsPeak: [],
  metricsVoice: [],
  metricsVideo: [],
  metricsRecording: [],
  metricsAUCMinute: 0,
  metricsAUCHour: 0,
  metricsAUCDay: 0,
  metricsAUCMonth: 0,
  metricsAUCPeak: 0,
  metricsAVoMMonth: 0,
  metricsAViMMonth: 0,
  metricsAVoMToday: 0,
  metricsAViMToday: 0,
  metricsAReMToday: 0,
  metricsPlatform: [],
  metricsPlatformVersion: [],
  metricsVersionSupport: false,
  metricsPlanSupport: false,
  metricsPlatformVersionData: [],
  metricsLoading: false,
  metricsUpdateSuccess: false,
}

export default function metricsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
